import React from 'react'

export default function Loading(props){
  return(
    <div className="loading-container">
      <div className="loader loader-primary">Loading...</div>
    </div>
  )
}